import React from 'react';
import './PageLoadingSpinner.scss';
import Spinner from './Spinner';

export default function PageLoadingSpinner() {
	return (
		<div className="page-loading-spinner__container">
			<Spinner />
		</div>
	);
}
